import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface readCSVLocationLinksCriteria {
    dashboardId: string;
    linkId: string;
    start: number;
    size: number;
}

class ReadCSVLocationLinksCriteriaImpl implements readCSVLocationLinksCriteria {
    constructor(readonly dashboardId: string, readonly linkId: string, readonly start: number, readonly size: number) {}
}

export class ReadCSVLocationLinksCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private linkId: Option<string> = none;

    private size = 500;

    private start = 0;

    static create = (): ReadCSVLocationLinksCriteriaBuilder => new ReadCSVLocationLinksCriteriaBuilder();

    withDashboardId = (dashboardId: string): ReadCSVLocationLinksCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withLinkId = (linkId: string): ReadCSVLocationLinksCriteriaBuilder => {
        this.linkId = some(linkId);
        return this;
    };

    withSize = (size: number): ReadCSVLocationLinksCriteriaBuilder => {
        this.size = size;
        return this;
    };

    withStart = (start: number): ReadCSVLocationLinksCriteriaBuilder => {
        this.start = start;
        return this;
    };

    build = (): readCSVLocationLinksCriteria => {
        if (isNone(this.dashboardId) || isNone(this.linkId) || this.size < 0 || this.start < 0) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadCSVLocationLinksCriteriaImpl(this.dashboardId.value, this.linkId.value, this.start, this.size);
    };
}
